<template>
  <div class="container">
    <HeadingOne class="-margin-md">暗証番号認証</HeadingOne>

    <template v-if="Object.keys(errors).length > 0">
      <ErrorsAlert :errors="errors"></ErrorsAlert>

      <form novalidate @submit.prevent="submitCheckPincode">
        <section>
          <TableGroup>
            <TableBox>
              <TableBody>
                <TableRow>
                  <TableHeader>暗証番号</TableHeader>
                  <TableData :has-error="errors['pincode']">
                    <InputGroup :errors="errors" :prop-names="['pincode']">
                      <InputgroupAppend>
                        <InputItem
                          id="confirmCode"
                          v-model="inputPincode.pincode"
                          class="-md"
                          type="password"
                          :maxlength="4"
                        ></InputItem>
                      </InputgroupAppend>
                    </InputGroup>
                  </TableData>
                </TableRow>
              </TableBody>
            </TableBox>
          </TableGroup>
        </section>

        <BtngroupSingle class="-margin-lg">
          <BtnMain class="-main" @click.prevent="submitCheckPincode">
            認証する
          </BtnMain>
        </BtngroupSingle>

        <BtngroupSingle class="-margin-lg">
          <BtnMain class="-normal" router-name="mb032">
            暗証番号を忘れた方はこちら
          </BtnMain>
        </BtngroupSingle>
      </form>
    </template>

    <template v-else-if="checkPincode.ng_count">
      <template v-if="checkPincode.ng_count < 3">
        <NoticeBox
          v-if="checkPincode.ng_count > 0"
          class="-error _mb-sm-40 _mb-md-60"
        >
          <NoticeHeader>
            <h3 class="heading">以下の内容をご確認ください。</h3>
          </NoticeHeader>
          <notice-body>
            <ul>
              <li>
                ご入力いただいた暗証番号が違います。ご確認のうえ再度入力してください。
              </li>
            </ul>
          </notice-body>
        </NoticeBox>
        <NoticeBox v-else class="-cancel _mb-sm-40 _mb-md-60">
          <NoticeHeader>
            <h3 class="heading">暗証番号をご入力ください。</h3>
          </NoticeHeader>
        </NoticeBox>

        <form novalidate @submit.prevent="submitCheckPincode">
          <section>
            <TableGroup>
              <TableBox>
                <TableBody>
                  <TableRow>
                    <TableHeader>暗証番号</TableHeader>
                    <TableData :has-error="errors['pincode']">
                      <InputGroup :errors="errors" :prop-names="['pincode']">
                        <InputgroupAppend>
                          <InputItem
                            id="confirmCode"
                            v-model="inputPincode.pincode"
                            class="-md"
                            type="password"
                            :maxlength="4"
                          ></InputItem>
                        </InputgroupAppend>
                      </InputGroup>
                    </TableData>
                  </TableRow>
                </TableBody>
              </TableBox>
            </TableGroup>
          </section>

          <BtngroupSingle class="-margin-lg">
            <BtnMain class="-main" @click.prevent="submitCheckPincode">
              認証する
            </BtnMain>
          </BtngroupSingle>

          <BtngroupSingle class="-margin-lg">
            <BtnMain class="-normal" router-name="mb032">
              暗証番号を忘れた方はこちら
            </BtnMain>
          </BtngroupSingle>
        </form>
      </template>

      <template v-else-if="checkPincode.ng_count >= 3">
        <NoticeBox class="-error _mb-sm-40 _mb-md-60">
          <NoticeHeader>
            <h3 class="heading">以下の内容をご確認ください。</h3>
          </NoticeHeader>
          <notice-body>
            <ul>
              <li>
                一定回数以上入力の誤りがあったため、暗証番号がロックされました。<br />「暗証番号の再設定へ」を押してロックを解除してください。
              </li>
            </ul>
          </notice-body>
        </NoticeBox>

        <BtngroupSingle class="-margin-lg">
          <BtnMain class="-normal" router-name="mb032">
            暗証番号の再設定へ
          </BtnMain>
        </BtngroupSingle>
      </template>
    </template>
  </div>
  <!-- container -->
</template>

<script>
import { initCredentials } from "@/utils/Auth";
import {
  checkPincodeLambdaInvoke,
  getUserDataLambdaInvoke,
} from "@/utils/LambdaHelper";
import { inputItemsMb } from "@/constants/constant";
import { setMeta } from "@/utils/Meta";
import { goToErrorPage, scrollTop } from "@/utils/Other";

import ErrorsAlert from "@/components/alert/ErrorsAlert";
import HeadingOne from "@/components/heading/HeadingOne";
import TableGroup from "@/components/tables/TableGroup";
import TableBox from "@/components/tables/TableBox";
import TableBody from "@/components/tables/TableBody";
import TableRow from "@/components/tables/TableRow";
import TableData from "@/components/tables/TableData";
import TableHeader from "@/components/tables/TableHeader";
import InputGroup from "@/components/input/InputGroup";
import InputItem from "@/components/input/InputItem";
import BtngroupSingle from "@/components/button/BtngroupSingle";
import BtnMain from "@/components/button/BtnMain";
import NoticeBox from "@/components/box/NoticeBox";
import NoticeHeader from "@/components/box/NoticeHeader";
import NoticeBody from "@/components/box/NoticeBody";
import InputgroupAppend from "@/components/input/InputgroupAppend";

export default {
  name: "Mb010",
  components: {
    InputgroupAppend,
    NoticeHeader,
    NoticeBox,
    NoticeBody,
    BtnMain,
    BtngroupSingle,
    InputItem,
    InputGroup,
    TableGroup,
    TableBox,
    TableBody,
    TableRow,
    TableHeader,
    TableData,
    HeadingOne,
    ErrorsAlert,
  },
  setup() {
    setMeta({
      title: "暗証番号認証",
      description:
        "au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,会員,会員サイト",
    });
  },
  data() {
    return {
      errors: {},
      isDisabled: false,
      inputPincode: {
        pincode: "",
        auth_kind: this.$route.query.auth_kind,
      },
      pageId: this.$route.query.page_id,
      checkPincode: {
        pincode: "",
        message_code: "",
        verification_result: "",
        ng_count: "",
      },
      inputItemsMb: inputItemsMb,
    };
  },
  mounted() {
    try {
      getUserDataLambdaInvoke()
        .then((res) => {
          let pincodeNgcount = res["pincode_ngcount"] || "0";
          if (pincodeNgcount > 2) {
            this.checkPincode.ng_count = pincodeNgcount;
          } else {
            this.checkPincode.ng_count = "0";
          }
        })
        .catch((error) => {
          goToErrorPage(error);
        });
    } catch (e) {
      goToErrorPage(e);
    }
  },
  methods: {
    submitCheckPincode: function () {
      try {
        if (this.isDisabled) {
          return;
        }
        this.isDisabled = true;
        this.errors = {};

        initCredentials()
          .then(() => {
            checkPincodeLambdaInvoke(this.inputPincode)
              .then((res) => {
                this.errors = res.errors || {};
                if (Object.keys(this.errors).length > 0) {
                  scrollTop();
                  this.isDisabled = false;
                } else if (Object.prototype.hasOwnProperty.call(res, "body")) {
                  let resBody = JSON.parse(res.body);
                  for (let key in resBody) {
                    if (
                      Object.prototype.hasOwnProperty.call(
                        this.checkPincode,
                        key
                      )
                    ) {
                      this.checkPincode[key] = resBody[key];
                    }
                  }
                  if (this.checkPincode.verification_result === "true") {
                    let pageName = this.pageId.toLowerCase().replace("-", "");
                    this.$router.push({ name: pageName });
                  } else {
                    // this.checkPincode.ng_count の値でメッセージを表示する
                    scrollTop();
                    this.isDisabled = false;
                  }
                } else {
                  this.$router.push({ name: "SessionTimeOut" });
                }
              })
              .catch((error) => {
                goToErrorPage(error);
              });
          })
          .catch((error) => {
            goToErrorPage(error);
          });
      } catch (e) {
        goToErrorPage(e);
      }
    },
  },
};
</script>

<style scoped></style>
